import { render, staticRenderFns } from "./SidenavRouterLink.vue?vue&type=template&id=1866bf93&"
import script from "./SidenavRouterLink.vue?vue&type=script&lang=js&"
export * from "./SidenavRouterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/code/nathan/Sonido_SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1866bf93')) {
      api.createRecord('1866bf93', component.options)
    } else {
      api.reload('1866bf93', component.options)
    }
    module.hot.accept("./SidenavRouterLink.vue?vue&type=template&id=1866bf93&", function () {
      api.rerender('1866bf93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/src/vendor/libs/sidenav/SidenavRouterLink.vue"
export default component.exports